import React from 'react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const BrandDetailStatisticChart = (props) => {
  const { data } = props;

  return (
    <div className="brand-detail-statistic-chart">
      <ResponsiveContainer height={370}>
        <LineChart
          width={1000}
          height={700}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Legend />
          <Line name="브랜드 찜 수" yAxisId="count" type="monotone" dataKey="storeLike" stroke="#FF0000" />
          <XAxis dataKey="date" />
          <YAxis yAxisId="count" label={{ value: '건수', angle: -90, position: 'insideBottom' }} />
          <YAxis
            yAxisId="price"
            label={{ value: '가격', angle: 90, position: 'insideBottomRight' }}
            orientation="right"
          />
          <Line
            name="브랜드 상세 페이지 조회 수"
            yAxisId="count"
            type="monotone"
            dataKey="storeClick"
            stroke="#FF8000"
          />
          <Line name="제품상세 유입" yAxisId="count" type="monotone" dataKey="productDetailClick" stroke="#00FF00" />
          <Line name="판매액" yAxisId="price" type="monotone" dataKey="sumTotalPrice" stroke="#0101DF" />
          <Line name="판매건수" yAxisId="count" type="monotone" dataKey="sumOrderCase" stroke="#8904B1" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BrandDetailStatisticChart;
